const validateCpf = require('iscpf');

const isCpf = cpf =>
  cpf
    ? !cpf.replace(/[._-]+/gi, '').match(/^(.)\1+$/) && validateCpf(cpf)
    : true

module.exports = isCpf

const isCpfForField = cpf => {
  return cpf
    ? (!cpf.replace(/[._-]+/gi, '').match(/^(.)\1+$/) && validateCpf(cpf)) || cpf.length < 14
    : true
}

module.exports = isCpfForField